import { useState, type FormEvent } from 'react';
import { Alert, Button, Card, Center, PasswordInput, Stack, TextInput, Title } from '@buildex/ui';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { loginFx } from '@buildex/core';

export function LoginPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pending, submit] = useUnit([loginFx.pending, loginFx]);
  const [failed, setFailed] = useState(false);

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    setFailed(false);
    submit({ email, password }).catch(() => setFailed(true));
  };

  return (
    <Center h="100vh">
      <Card withBorder w={380} padding="xl">
        <form onSubmit={onSubmit}>
          <Stack gap="sm">
            <Title order={3} ta="center">
              {t('login.title')}
            </Title>
            {failed ? <Alert color="red">{t('login.error')}</Alert> : null}
            <TextInput
              label={t('login.email')}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <PasswordInput
              label={t('login.password')}
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <Button type="submit" loading={pending} fullWidth mt="sm">
              {t('login.submit')}
            </Button>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}
